module.exports = __webpack_public_path__ + "img/botpress.23574a01.svg";